import auth from "../../../../Auth";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import withValueField from "../../../../Shared/withValueField";
import { DropDownList, MultiSelect, MultiSelectFilterChangeEvent } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import axios from "axios";
import { errorToastr, RemoveSecFromTime, successToastr, toLocalDateTime } from "../../../../../HelperMethods";
import { ErrorComponent } from "../../../../ReusableComponents";
import { IDropDownModel } from "../../../../Shared/Models/IDropDownModel";
import { filterBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import { end, TimePicker } from "@progress/kendo-react-dateinputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import clientAdminService from "../../Service/DataService";
import { DEF_SHIFT_CREATED_SUCCESS_MSG, DEF_SHIFT_DURATION_ERROR_MSG, DEF_SHIFT_TIME_ERROR_MSG, DEF_SHIFT_UPDATED_SUCCESS_MSG } from "../../../../Shared/AppMessages";
//import lookup from "../../../../Lookup/Services";
import Service from "../../../../Scheduling/Service/Service";

const CustomDropDownList = withValueField(DropDownList);
const defaultItem = { clientPosition: "Select Position..", id: null };

export interface CreateDefaultShiftProps {
    props: any;
    onCloseModal: any;
    onOpenModal: any;
    locationId: string;
    departmentId: string;
}

export interface CreateDefaultShiftState {
    shiftId?: string;
    name?: string;
    clientId: string;
    duration?: any;
    submitted: boolean;
    showLoader?: boolean;
    shiftStartTime?: Date;
    shiftEndTime?: Date;
    positions: Array<IDropDownModel>;
    originalpositions: Array<IDropDownModel>;
    selectedPositions: any;
    clientPositions: Array<IDropDownModel>;
    originalclientPositions: Array<IDropDownModel>;
    clientPositionId?: string;
    shiftTypes: Array<IDropDownModel>;
    shiftType?: IDropDownModel;
}

class CreateDefaultShift extends React.Component<CreateDefaultShiftProps, CreateDefaultShiftState> {
    public totalDuration: any;
    public defaultShiftId: any;
    constructor(props: CreateDefaultShiftProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            shiftStartTime: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
            shiftEndTime: new Date(new Date(new Date().setHours(17)).setMinutes(30)),
            name: "",
            submitted: false,
            positions: [],
            originalpositions: [],
            showLoader: true,
            selectedPositions: [],
            clientPositions: [],
            originalclientPositions: [],
            shiftTypes:[]
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getPositions();
        this.getShiftTypes();
        
        
        if (this.props.props) {

            this.setState({
                shiftId: this.props.props.shiftId,
                name: this.props.props.shift,
                shiftStartTime: this.props.props.startTime,
                shiftEndTime: this.props.props.endTime,
                duration: this.props.props.duration,
                clientPositionId: this.props.props.positionId,
            })
        } 
    }

    getShiftTypes = () => {
        Service.getShiftTypeLookup()
            .then(async res => {
                var filteredShiftType: any;
                this.setState({ shiftTypes: res.data });
                if (this.props.props && this.props.props.shiftTypeId) {
                    filteredShiftType = res.data.filter(item => { return item.id == this.props.props.shiftTypeId })
                }
                else {
                    filteredShiftType = res.data.filter(item => { return item.isDefault })
                }
                if (filteredShiftType && filteredShiftType.length > 0)
                    this.defaultShiftId = filteredShiftType[0];
                this.setState({
                    shiftType: this.defaultShiftId 
                })
            });
    }

    getPositions = () => {
        this.setState({ showLoader: false });
        let queryParams = `clientId eq ${this.state.clientId}`;
        clientAdminService.getClientPositions(queryParams)
            .then(async res => {
                this.setState({ positions: res.data, originalpositions: res.data, clientPositions: res.data, originalclientPositions: res.data });
            });
    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterChange = (event: MultiSelectFilterChangeEvent) => {
        this.setState({
            positions: filterBy(this.state.originalpositions.slice(), event.filter),
        });
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    isCustom = (item) => { return item.id === undefined; }

    addKey = (item) => { item.id = undefined }

    handlePositionsChange = (e) => {
        this.setState({ selectedPositions: e.value });
    }

    handleChange = (e) => {
        this.setState({ clientPositionId: e.value.id });
    }

    openNew = () => {
        this.props.onOpenModal();
    };

    handleSaveAndClose = () => {
        // let totalDuration = 0;
        // let timeOut = RemoveSecFromTime(this.state.shiftEndTime);
        // let timeIn = RemoveSecFromTime(this.state.shiftStartTime);
        // totalDuration = (timeOut - timeIn) / 36e5;
        this.setState({ submitted: true })
        let isValid = this.checkValidations(this.state.shiftStartTime, this.state.shiftEndTime, this.totalDuration);
        if (isValid) {
            let data = {
                locationId: this.props.locationId,
                departmentId: this.props.departmentId,
                shift: this.state.name,
                startTime: toLocalDateTime(this.state.shiftStartTime),
                endTime: toLocalDateTime(this.state.shiftEndTime),
                duration: this.totalDuration,
                shiftPositions: this.state.selectedPositions,
                shiftTypeId: this.state.shiftType.id
            };
            if ((this.state.name.trim() != undefined && this.state.name.trim() != null && this.state.name.trim() != "") && (this.state.shiftStartTime != undefined && this.state.shiftStartTime != null)
                && (this.state.shiftEndTime != undefined && this.state.shiftEndTime != null) && (this.state.selectedPositions != undefined && this.state.selectedPositions.length > 0 && this.state.selectedPositions != null)) {
                axios.post(`api/clientadmin/department/${this.props.departmentId}/shift`, JSON.stringify(data)).then((res) => {
                    successToastr(DEF_SHIFT_CREATED_SUCCESS_MSG);
                    this.props.onCloseModal();
                });
            }
        }
    }

    checkValidations(shiftStartTime, shiftEndTime, totalDuration) {
        debugger
        // if (shiftEndTime <= shiftStartTime) {
        //     errorToastr(DEF_SHIFT_TIME_ERROR_MSG);
        //     return false;
        // }
        if (totalDuration > 24) {
            errorToastr(DEF_SHIFT_DURATION_ERROR_MSG);
            return false;
        }        
        return true;
    }

    handleSaveAndAddAnother = () => {
        // let totalDuration = 0;
        // let timeOut = RemoveSecFromTime(this.state.shiftEndTime);
        // let timeIn = RemoveSecFromTime(this.state.shiftStartTime);
        // totalDuration = (timeOut - timeIn) / 36e5;
        this.setState({ submitted: true })
        let isValid = this.checkValidations(this.state.shiftStartTime, this.state.shiftEndTime, this.totalDuration);
        if (isValid) {
            let data = {
                locationId: this.props.locationId,
                departmentId: this.props.departmentId,
                shift: this.state.name,
                startTime: toLocalDateTime(this.state.shiftStartTime),
                endTime: toLocalDateTime(this.state.shiftEndTime),
                duration: this.totalDuration,
                shiftPositions: this.state.selectedPositions,
                shiftTypeId: this.state.shiftType.id
            };
            if ((this.state.name.trim() != undefined && this.state.name.trim() != null && this.state.name.trim() != "") && (this.state.shiftStartTime != undefined && this.state.shiftStartTime != null)
                && (this.state.shiftEndTime != undefined && this.state.shiftEndTime != null) && (this.state.selectedPositions != undefined && this.state.selectedPositions.length > 0 && this.state.selectedPositions != null)) {
                axios.post(`api/clientadmin/department/${this.props.departmentId}/shift`, JSON.stringify(data)).then((res) => {
                    successToastr(DEF_SHIFT_CREATED_SUCCESS_MSG);
                    this.props.onCloseModal();
                    setTimeout(() => {
                        this.openNew();
                    }, 50);
                });
            }
        }
    }

    handleUpdate = () => {
        // let totalDuration = 0;
        // let timeOut = RemoveSecFromTime(this.state.shiftEndTime);
        // let timeIn = RemoveSecFromTime(this.state.shiftStartTime);
        // totalDuration = (timeOut - timeIn) / 36e5;
        this.setState({ submitted: true })
        let isValid = this.checkValidations(this.state.shiftStartTime, this.state.shiftEndTime, this.totalDuration);
        if (isValid) {
            let data = {
                defaultShiftId: this.state.shiftId,
                locationId: this.props.locationId,
                departmentId: this.props.departmentId,
                shift: this.state.name,
                startTime: toLocalDateTime(this.state.shiftStartTime),
                endTime: toLocalDateTime(this.state.shiftEndTime),
                duration: this.totalDuration,
                positionId: this.state.clientPositionId,
                shiftTypeId: this.state.shiftType.id

            };
            console.log(data, "sdh");
            if ((this.state.name.trim() != undefined && this.state.name.trim() != null && this.state.name.trim() != "") && (this.state.shiftStartTime != undefined && this.state.shiftStartTime != null)
                && (this.state.shiftEndTime != undefined && this.state.shiftEndTime != null) && (this.state.clientPositionId != undefined && this.state.clientPositionId != null)) {
                axios.put(`api/clientadmin/department/shift/${this.state.shiftId}`, JSON.stringify(data)).then((res) => {
                    successToastr(DEF_SHIFT_UPDATED_SUCCESS_MSG);
                    this.props.onCloseModal();
                });
            }
        }
    }

  
    handleShiftTypeChange = (e) => {
        this.setState({
            shiftType: e.target.value
        })
      
    };
    render() {
        this.totalDuration = 0;
        let timeOut = RemoveSecFromTime(this.state.shiftEndTime);
        let timeIn = RemoveSecFromTime(this.state.shiftStartTime);
        if((this.state.shiftEndTime != null || this.state.shiftEndTime != undefined) && this.state.shiftEndTime < this.state.shiftStartTime){
            timeOut = new Date(this.state.shiftEndTime).setDate(new Date(this.state.shiftEndTime).getDate() + 1);
            timeOut = RemoveSecFromTime(timeOut);
        }
        this.totalDuration = (timeOut - timeIn) / 36e5;
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {this.props.props !== undefined ? "Edit Shift" : "Add New Shift"}
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    {this.state.showLoader &&
                        Array.from({ length: 2 }).map((item, i) => (
                            <div className="row mx-auto mt-2" key={i}>
                                {Array.from({ length: 3 }).map((item, j) => (
                                    <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                        <Skeleton width={230} />
                                        <Skeleton height={30} />
                                    </div>
                                ))}
                            </div>
                        ))}
                    {!this.state.showLoader && (
                        <div className="model-body">
                            <div className="row mt-3 mx-0">
                                <div className="col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Shift Name</label>
                                    <input
                                        type="text"
                                        className="form-control mt-1"
                                        placeholder="Enter Shift Name"
                                        value={this.state.name}
                                        maxLength={100}
                                        onChange={(event) => {
                                            this.setState({ name: event.target.value });
                                        }}
                                    />
                                    {this.state.submitted && (this.state.name.trim() == undefined || this.state.name.trim() == null || this.state.name.trim() == "") && <ErrorComponent />}
                                </div>
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                    <label className="mb-1 font-weight-bold required">Start Time</label>
                                    <div className="row">
                                        <div className="col-12">
                                            <TimePicker
                                                className="form-control"
                                                format="hh:mm a"
                                                name="shiftStartTime"
                                                value={new Date(this.state.shiftStartTime)}
                                                //max={new Date(this.state.shiftEndTime)}
                                                onChange={(event) => {
                                                    this.setState({ shiftStartTime: event.target.value });
                                                }}
                                            />
                                            {this.state.submitted && (this.state.shiftStartTime == undefined || this.state.shiftStartTime == null) && <ErrorComponent />}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4 mt-1 mt-sm-0" id="ShowDatePickerIcon">
                                    <label className="mb-1 font-weight-bold  required">End Time</label>
                                    <div className="row">
                                        <div className="col-12">
                                            <TimePicker
                                                className="form-control"
                                                format="hh:mm a"
                                                //min={new Date(this.state.shiftStartTime)}
                                                name="shiftEndTime"
                                                value={new Date(this.state.shiftEndTime)}
                                                onChange={(event) => {
                                                    this.setState({ shiftEndTime: event.target.value });
                                                }}
                                            />
                                            {this.state.submitted && (this.state.shiftEndTime == undefined || this.state.shiftEndTime == null) && <ErrorComponent />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3 mx-0">
                                <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                    <label className="mb-1 font-weight-bold">Duration (In Hrs)</label>
                                    <NumericTextBox
                                        className="form-control text-right"
                                        disabled={true}
                                        name="duration"
                                        placeholder="Enter Duration"
                                        value={isNaN(this.totalDuration) ? 0 : this.totalDuration}
                                        title="Maximum value could be 99999."
                                        max={99999}
                                        min={0}
                                        spinners={false}
                                    />
                                </div>
                                {
                                    this.props.props !== undefined ?
                                        <div className="col-sm-4 mt-1 mt-sm-0">
                                            <label className="mb-0 font-weight-bold required">Position</label>
                                            <CustomDropDownList
                                                className="form-control mt-1"
                                                data={this.state.clientPositions}
                                                textField="clientPosition"
                                                valueField="id"
                                                id="clientPositions"
                                                name="id"
                                                value={this.state.clientPositionId}
                                                onChange={(e) => this.handleChange(e)}
                                                filterable={this.state.originalclientPositions.length > 5 ? true : false}
                                                onFilterChange={this.handleFilterChange}
                                            />
                                            {this.state.submitted && (this.state.clientPositionId == undefined || this.state.clientPositionId == null) && <ErrorComponent />}
                                        </div>
                                        :
                                        <div className="col-sm-4 mt-1 mt-sm-0">
                                            <label className="mb-1 font-weight-bold required">Position</label>
                                            <MultiSelect
                                                className="form-control disabled"
                                                data={this.state.positions}
                                                textField="clientPosition"
                                                dataItemKey="id"
                                                id="clientPositions"
                                                value={this.state.selectedPositions}
                                                onChange={(e) => this.handlePositionsChange(e)}
                                                placeholder="Select Positions..."
                                                filterable={true}
                                                onFilterChange={this.filterChange}
                                            />
                                            {this.state.submitted && (this.state.selectedPositions == undefined || this.state.selectedPositions.length == 0 || this.state.selectedPositions == null) && <ErrorComponent />}
                                        </div>
                                }
                                <div className="col-sm-4 mt-1 mt-sm-0">
                                    <label className="mb-0 font-weight-bold required">Shift Type</label>
                                    <DropDownList
                                        className={"form-control"}
                                        data={this.state.shiftTypes}
                                        value={this.state.shiftType}
                                        textField="name"
                                        dataItemKey="id"
                                        onChange={(e) => this.handleShiftTypeChange(e)}
                                        id="shiftTypes"
                                        name="shiftType"/>
                                    
                                </div>
                               
                            </div>
                        </div>
                    )}


                    <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                            {this.props.props !== undefined
                                ? <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleUpdate}>
                                    <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                </button>
                                : <React.Fragment>
                                    <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSaveAndAddAnother}>
                                        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Add Another
                                    </button>
                                    <button type="button" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={this.handleSaveAndClose}>
                                        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save & Close
                                    </button>
                                </React.Fragment>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CreateDefaultShift;